import { useCallback, useEffect } from "react"
import { useLocation } from "react-router";
import { useHistory } from "react-router";
import { appPath, getRememberedAppSlug } from "../utils/appSlug";
import { decodeAccessToken } from "../utils/session";

const AuthVerify = ({ loginStatus, setLoginStatus }) => {
  const location = useLocation()
  const history = useHistory()

  const logoutUser = useCallback((reason) => {
    localStorage.removeItem('user');
    setLoginStatus({})
    localStorage.removeItem('authError')
    const slug = getRememberedAppSlug();
    history.push(slug ? appPath(slug, "login") : "/login", {failReason:reason})
  }, [setLoginStatus, history]);

  useEffect(() => {
    const raw = localStorage.getItem('user');
    if (!raw) return;

    let user;
    try {
      user = JSON.parse(raw);
    } catch {
      return;
    }

    const decodedJwt = decodeAccessToken(user?.access_token);
    if (!decodedJwt?.sub) return;

    if (decodedJwt.exp && decodedJwt.exp * 1000 < Date.now()) {
      logoutUser("Sessione scaduta, per favore rieffettua l'accesso")
      return;
    }
    if (decodedJwt.is_verified === false) {
      logoutUser("Utente non verificato, controlla la tua email per attivare il tuo account o contatta infoceformedsrl@gmail.com")
      return;
    }
    if (localStorage.getItem('authError') === "true") {
      localStorage.removeItem('authError');
      logoutUser("Sessione scaduta, per favore rieffettua l'accesso")
      return;
    }
    if (!loginStatus?.sub) {
      setLoginStatus(decodedJwt);
    }
  }, [location.pathname, loginStatus, setLoginStatus, logoutUser])

  return null
}

export default AuthVerify
